<template>
  <div class="wrapper">
    <div class="wrapper-header">
      <TabsWidget @tab="switchTab" activeTab="playlist" />
      <div class="tab-options">
        <b-button type="is-primary" @click="toggleModal = true">ADD NEW</b-button>
      </div>
    </div>

    <div class="wrapper-playlists" v-if="allPlaylists.length > 0 && !loading && !showItems"
      :class="{ activeSide: $store.state.sidebar }">
      <div class="playlist-group" v-for="(playlist, index) in allPlaylists" :key="index">
        <h1 class="playlist-group-title">{{ playlist.playlist_category }}</h1>
        <div class="playlist-group-data">
          <div class="playlist-group-data-each" v-for="(eachplaylist, index) in playlist.playlists" :key="index">
            <div class="playlist-group-data-each-cover">
              <div class="playlist-action">
                <b-dropdown aria-role="list" class="is-pulled-right" position="is-bottom-right">
                  <template #trigger>
                    <b-icon icon="dots-vertical" type="is-white"></b-icon>
                  </template>
                  <b-dropdown-item @click="toggleModal = true; update_playlist = eachplaylist"
                    aria-role="listitem">Update</b-dropdown-item>
                  <b-dropdown-item @click="deletePlaylist(eachplaylist.id)"
                    aria-role="listitem">Delete</b-dropdown-item>
                </b-dropdown>
              </div>
              <img v-if="eachplaylist.cover"
                :src="$store.state.ASSETS_BASE_URL + 'assets/uploaded/' + eachplaylist.cover" alt="Cover Image">
              <b-skeleton v-else id="img-skeleton"></b-skeleton>
              <b-button type="is-success" class="" @click="viewDetails(eachplaylist)">View</b-button>
            </div>
            <h1>{{ eachplaylist.name }}</h1>
          </div>
        </div>
      </div>
    </div>

    <div class="wrapper-body" v-if="selected_playlist || loadingItems" :class="{ activeSide: $store.state.sidebar }">
      <h1 class="wrapper-body-title">
        <b-button type="is-primary" outlined
          @click="selected_playlist = null; showItems = false; loadingItems = false">Back</b-button>
        {{ playlist_name }}
      </h1>
      <widgetNotfound v-if="loadingItems" title="Please Wait..." subtitle="Loading Data..."></widgetNotfound>
      <widgetNotfound v-if="selected_playlist && selected_playlist.length == 0" title="No Data..."
        subtitle="No Media Under This Playlist..."></widgetNotfound>
      <div class="wrapper-body-inner" v-else>
        <dataCard @edit="edit(data)" v-for="(data, index) in selected_playlist" :key="index" :dataObj='data' />
      </div>
    </div>

    <div v-if="allPlaylists.length == 0 || loading == true">
      <widgetNotfound v-if="loading" title="Please Wait..." subtitle="Loading Data..."></widgetNotfound>
      <widgetNotfound v-else title="No Data Found" subtitle="No records available at the moment. Add New">
      </widgetNotfound>
    </div>
    <addNewPlaylist v-if="toggleModal"
      @refresh="loading = true; getAllPlaylists(); showItems = false; loadingItems = false"
      @closeModal="toggleModal = false;" :dataObj="update_playlist" />
  </div>
</template>

<script>
import dataCard from './components/dataCard.vue';
import addNewPlaylist from './modals/addNewPlaylist.vue';
import TabsWidget from './components/TabsWidget.vue';
export default {
  data() {
    return {
      selected_playlist: null,
      toggleModal: false,
      loading: false,
      playlists: [],
      allPlaylists: [],
      update_playlist: null,
      playlist_name: '',
      loadingItems: false,
      showItems: false,
    }
  },
  components: { dataCard, addNewPlaylist, TabsWidget },
  mounted() {
    let vm = this;
    vm.getAllPlaylists();
  },
  methods: {
    switchTab(type) {
      let vm = this;
      vm.$emit("tab", type);
    },
    viewDetails(data) {
      let vm = this;
      vm.loadingItems = true;
      vm.playlist_name = data.name;
      vm.showItems = true;
      vm.$store.dispatch('GET_PLAYLIST_ITEMS', { id: data.id })
        .then(res => {
          vm.loadingItems = false;
          vm.selected_playlist = res.data.return;
        })
        .catch(err => {
          vm.loadingItems = false;
          console.log(err);
        })
    },
    getAllPlaylists() {
      let vm = this;
      vm.loading = true;
      vm.$store.dispatch('GET_PLAYLISTS', {})
        .then(res => {
          vm.loading = false;
          vm.allPlaylists = res.data.return;
        })
        .catch(err => {
          vm.loading = false;
          console.log(err);
        })
    },
    deletePlaylist(id) {
      let vm = this;
      vm.$buefy.dialog.confirm({
        title: 'Deleting Playlist',
        message: 'Are you sure you want to delete this playlist?',
        confirmText: 'Delete',
        type: 'is-danger',
        hasIcon: true,
        onConfirm: () => {
          vm.$store.dispatch('DELETE_PLAYLIST', { id: id })
            .then(res => {
              vm.$notify({
                group: "status",
                type: "success",
                title: "SUCCESS!!!",
                text: 'Playlist Deleted Successfully',
              });
              vm.loading = true;
              vm.getAllPlaylists();
            })
            .catch(err => {
              vm.$notify({
                group: "status",
                type: "error",
                title: "OOPS!!!",
                text: 'Something went wrong',
              });
              console.log(err);
            })
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.wrapper {
  padding: 0px;
  display: flex;
  flex-direction: column;
  height: 100%;

  .wrapper-header {
    width: 100%;
    height: fit-content;
    // height: 60px;
    background: #fff;
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-bottom: 1px solid #ddd;
    padding-left: 6px;
    overflow-x: auto;

    .tabs-widget {
      display: flex;
      align-items: flex-end;

      .h-spacer {
        margin-right: 20px;
      }

      .tab-item {
        cursor: pointer;
        padding: 14px 4px;
        border-bottom: 3px solid transparent;

        &.active {
          color: var(--wecodefy-secondary-color, #9fc953);
          border-bottom: 3px solid var(--wecodefy-secondary-color, #9fc953);
        }
      }
    }

    .tab-options {
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 0px 10px;

      .h-spacer {
        margin-right: 10px;
      }
    }
  }

  .wrapper-playlists {
    height: calc(100% - 60px);
    padding: 20px;
    row-gap: 50px;
    overflow-y: auto;
    // justify-content: space-between;
    display: flex;
    flex-direction: column;
    row-gap: 20px;

    &.activeSide {
      .playlist-group {
        .playlist-group-data {
          @media (max-width: 1219px) {
            grid-template-columns: repeat(6, calc(100%/6));
          }

          @media (max-width: 1050px) {
            grid-template-columns: repeat(5, calc(100%/5));
          }

          @media (max-width: 720px) {
            grid-template-columns: repeat(4, calc(100%/4));
          }

          @media (max-width: 590px) {
            grid-template-columns: repeat(3, calc(100%/3));
          }

          @media (max-width: 446px) {
            grid-template-columns: repeat(2, calc(100%/2));
          }

          @media (max-width: 344px) {
            grid-template-columns: repeat(1, 100%);
          }
        }
      }
    }

    .playlist-group {
      .playlist-group-title {
        font-weight: 600;
        text-transform: uppercase;
        margin-bottom: 20px;
      }

      .playlist-group-data {
        display: grid;
        grid-template-columns: repeat(7, calc(100%/7.3));
        justify-content: space-between;
        row-gap: 20px;

        @media (max-width: 987px) {
          grid-template-columns: repeat(6, calc(100%/6));
        }

        @media (max-width: 818px) {
          grid-template-columns: repeat(5, calc(100%/5));
        }

        @media (max-width: 720px) {
          grid-template-columns: repeat(4, calc(100%/4));
        }

        @media (max-width: 590px) {
          grid-template-columns: repeat(3, calc(100%/3));
        }

        @media (max-width: 446px) {
          grid-template-columns: repeat(2, calc(100%/2));
        }

        @media (max-width: 344px) {
          grid-template-columns: repeat(1, 100%);
        }

        .playlist-group-data-each {
          padding: 7px;
          border-radius: 5px;
          transition: .5s;
          cursor: pointer;

          &:hover {
            background: rgb(216, 216, 216);

            .playlist-group-data-each-cover {
              img {
                transform: scale(1.1);
              }
            }
          }

          .playlist-group-data-each-cover {
            width: 100%;
            height: 170px;
            border-radius: 5px;
            margin-bottom: 5px;
            position: relative;

            .button {
              position: absolute;
              bottom: 7px;
              right: 7px;
            }

            img {
              width: 100%;
              height: 100%;
              object-fit: cover;
              transform: scale(1);
              transition: .5s;
            }

            .playlist-action {
              position: absolute;
              width: 30px;
              height: 30px;
              top: 5px;
              right: 5px;
              z-index: 1;
            }

            .b-skeleton.is-animated {
              height: 100%;

              .b-skeleton-item.is-rounded {
                height: 100%;
              }
            }
          }

          h1 {
            text-align: center;
            opacity: .8;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 2;
            text-overflow: ellipsis;
            overflow: hidden;
          }
        }
      }
    }

  }

  .wrapper-body {
    height: calc(100% - 60px);
    padding: 20px;
    overflow-y: auto;

    h1.wrapper-body-title {
      font-size: 18px;
      margin-bottom: 20px;
      text-transform: uppercase;
      font-weight: 600;
      display: flex;
      align-items: center;
      column-gap: 10px;
    }

    &.activeSide {
      .wrapper-body-inner {
        grid-template-columns: repeat(5, calc(100%/5.3));

        @media (max-width: 1300px) {
          grid-template-columns: repeat(4, calc(100%/4.25));
        }

        @media (max-width: 1100px) {
          grid-template-columns: repeat(3, calc(100%/3.15));
        }

        @media (max-width: 966px) {
          grid-template-columns: repeat(4, calc(100%/4.25));
        }

        @media (max-width: 768px) {
          grid-template-columns: repeat(3, calc(100%/3.15));
          row-gap: 30px;
        }

        @media (max-width: 600px) {
          grid-template-columns: repeat(2, calc(100%/2.05));
        }

        @media (max-width: 450px) {
          grid-template-columns: repeat(1, 1fr);
        }
      }
    }

    .wrapper-body-inner {
      display: grid;
      grid-template-columns: repeat(6, calc(100%/6.4));
      row-gap: 50px;
      justify-content: space-between;

      @media (max-width: 1307px) {
        grid-template-columns: repeat(5, calc(100%/5.3));
      }

      @media (max-width: 1000px) {
        grid-template-columns: repeat(4, calc(100%/4.25));
      }

      @media (max-width: 768px) {
        grid-template-columns: repeat(3, calc(100%/3.15));
        row-gap: 30px;
      }

      @media (max-width: 600px) {
        grid-template-columns: repeat(2, calc(100%/2.05));
      }

      @media (max-width: 450px) {
        grid-template-columns: repeat(1, 1fr);
      }
    }
  }
}
</style>